import { FooterActionsButtonContainerController } from './footer-actions-button-container.controller';
import { FooterActionsButtonContainerProps } from './footer-actions-button-container.model';

export const FooterActionsButtonContainerComponenet = (
  props: FooterActionsButtonContainerProps
) => {
  return <FooterActionsButtonContainerController {...props} />;
};
